import { render, staticRenderFns } from "./AddNewSuppliers.vue?vue&type=template&id=8ba85504&scoped=true"
import script from "./AddNewSuppliers.vue?vue&type=script&lang=js"
export * from "./AddNewSuppliers.vue?vue&type=script&lang=js"
import style0 from "./AddNewSuppliers.vue?vue&type=style&index=0&id=8ba85504&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba85504",
  null
  
)

export default component.exports